import JSOG from 'jsog';
import { Base64 } from 'js-base64';
import _ from 'underscore';

export function toUrlData(obj) {
  const encoded = encodeURIComponent(Base64.encode(JSOG.stringify(obj)));
  removeObjectIds(obj);
  return encoded;
}

const JSOG_OBJECT_ID = '__jsogObjectId';

function removeObjectIdArray(arr) {
  _.each(arr, removeObjectIds);
}

function removeObjectIdObject(obj) {
  if (obj[ JSOG_OBJECT_ID ]) {
    delete obj[ JSOG_OBJECT_ID ];
    // for each of the values
    _.each(obj, removeObjectIds);
  }
}

function removeObjectIds(obj) {
  if (_.isArray(obj)) {
    removeObjectIdArray(obj);
  } else if (_.isObject(obj)) {
    removeObjectIdObject(obj);
  }
}

export function fromUrlData(str) {
  if (typeof str !== 'string' || str.trim().length === 0) {
    return null;
  }
  try {
    return JSOG.parse(Base64.decode(decodeURIComponent(str)));
  } catch (err) {
    console.error(err);
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/js/util/UrlParams.js